import React, { useCallback } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useQuery } from '@apollo/client';
import PageContainer from 'components/@layout/PageContainer';
import PrintLoginCard from 'components/PrintScreenModule/LoginCards/components/LoginCard';
import Typography from '@material-ui/core/Typography';
import GET_CLASSROOM from 'graph/classroom/get-classroom-query';
import getClassroomPrimaryEducator from 'utilities/get-classroom-primary-eduator';
import { Student } from 'types/schema-generated-types';
import { usePageContentLoading } from 'providers/PageContentLoadingProvider';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      padding: theme.spacing(2.5)
    },
    header: {
      borderBottom: `2px solid ${theme.palette.common.black}`,
      marginBottom: theme.spacing(1)
    },
    title: {
      paddingBottom: theme.spacing(1),
      fontSize: theme.typography.pxToRem(28)
    }
  };
});

interface StudentLoginCardContainerProps {
  studentId: number;
  classroomId: number;
  product: string;
}

const StudentLoginCardContainer: React.FC<StudentLoginCardContainerProps> = ({
  studentId,
  classroomId,
  product
}) => {
  const classes = useStyles();
  const [, { setLoading }] = usePageContentLoading();
  const { data, loading, error } = useQuery(GET_CLASSROOM, {
    variables: { id: classroomId }
  });
  const educatorPin = useCallback(() => getClassroomPrimaryEducator(data?.classroom)?.pin, [data]);
  const getStudent = useCallback(
    () => data?.classroom?.students?.find((x: Student) => x.id === studentId),
    [data, studentId]
  );
  const student = getStudent();

  const handleOnLoad = (): void => {
    setLoading(false);
  };

  return (
    <PageContainer loading={loading} error={error}>
      <div className={classes.container}>
        <div className={classes.header}>
          {student && (
            <Typography variant="h3" className={classes.title}>
              Student Name: {student.firstName} {student.lastName}
            </Typography>
          )}
        </div>
        <div>
          {student && (
            <PrintLoginCard
              key={`print-login-card-${student.id}`}
              product={product}
              firstName={student.firstName}
              lastName={student.lastName}
              educatorPin={educatorPin() || ''}
              password={student.password || ''}
              username={student.username}
              onLoad={handleOnLoad}
            />
          )}
        </div>
      </div>
    </PageContainer>
  );
};

export default StudentLoginCardContainer;
